import { RootState } from 'handlers';

export const getApplicationStep = ({ applicationStep }: RootState) => applicationStep;
